import React, { useState, useEffect } from "react";
import SwipeableViews from "react-swipeable-views";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Box, Tabs, Tab, TextField, Typography, Grid, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GiCancel } from "react-icons/gi";

import UpdateDateFromExcel from "./UpdateDateFromExcel";
import PlannedMaintenanceTable from "./PlannedMaintenanceTable";

import { postUpdateTaskDatesFromExcel, postExportTasksForUpdateDate } from "../../store/actions/PlannedMaintenanceUpdateActions";
import { getList } from "../../store/actions/PlannedMaintenanceListActions";
import { getMaintenanceType } from "../../store/actions/PMActions";
import { FaUpload } from "react-icons/fa";
import GetAppIcon from "@mui/icons-material/GetApp";

import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";

function PlannedMaintenanceUpdate() {
    const ls = localStorage;
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    const [plannedMaintenanceExcel, setPlannedMaintenanceExcel] = useState([]);

    const [warningList, setWarningList] = useState([]);

    const [disableExcel, setDisableExcel] = useState(false);
    const [disableUpload, setDisableUpload] = useState(true);
    const [disableCancel, setDisableCancel] = useState(true);

    const [tabId, setTabId] = useState(0);
    const [poolData, setPoolData] = useState([]);
    const [poolIds, setPoolIds] = useState([]);
    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState([]);
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState([]);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
    const [excelFilterState, setExcelFilterState] = useState({});

    const { PlannedMaintenanceUpdateReducer } = useSelector((state) => state);
    const [formData, setFormData] = useState(new FormData());

    useEffect(() => {
        dispatch(getList());
        dispatch(getMaintenanceType());
    }, []);

    useEffect(() => {
        if (PlannedMaintenanceUpdateReducer?.data) {
            setWarningList([]);
            setFormData(new FormData());
            setDisableUpload(true);
            setDisableExcel(false);
            setDisableCancel(true);
        }
        if (PlannedMaintenanceUpdateReducer?.uploadResponse) {
            if(PlannedMaintenanceUpdateReducer.uploadResponse.errorCode === 0) {
            setWarningList([]);
            setDisableCancel(true);
            setDisableExcel(false);
            setDisableUpload(true);
            window.location.reload();
            }
        }
    }, [PlannedMaintenanceUpdateReducer]);

    const PlannedMaintenanceList = useSelector((state) => state.PlannedMaintenanceList);
    useEffect(() => {
        if (PlannedMaintenanceList.poolList) {
            setPoolData(Object.values(PlannedMaintenanceList.poolList));
        }
    }, [PlannedMaintenanceList.poolList]);

    const { pm } = useSelector((pm) => pm);
    useEffect(() => {
        if (pm?.maintenanceType.errorCode === 0) {
            setMaintenanceTypes(pm.maintenanceType.resultObject);
        }
    }, [pm.maintenanceType]);

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
                <Box>{children}</Box>
            </Typography>
        );
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const cancelUpload = () => {
        setWarningList([]);
        setDisableCancel(true);
        setDisableExcel(false);
        window.location.reload();
    };

    const uploadExcel = () => {
        let payload = {
            data: formData,
        };
        dispatch(postUpdateTaskDatesFromExcel(payload));
    };

    const callBackTabData = (_tabId, excelData) => {
        if (excelData.excelList.errorCode === 0) {
            setPlannedMaintenanceExcel(excelData?.excelList.resultObject);
            setTabId(_tabId);
            setDisableExcel(true);
            setDisableCancel(false);
            setDisableUpload(false);

            if (excelData.excelList.resultObject.warnings?.length > 0) {
                setWarningList(excelData?.uploadResponse.resultObject.warnings);
            }
        }
    };

    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            "aria-controls": `scrollable-auto-tabpanel-${index}`,
        };
    };

    // Set pool
    const HandlePool = (poolName) => {
        let ids = [];
        poolName.map((item) => ids.push(item.id));
        setPoolIds(ids);
    };

    const HandleMaintenanceTypeChange = (maintenanceName) => {
        if (maintenanceName !== null) {
            let filteredTypes = [];
            let filteredTypeNames = [];
            maintenanceTypes.forEach((item) => {
                maintenanceName.forEach((name) => {
                    if (item.name === name) {
                        filteredTypes.push(item.id);
                        filteredTypeNames.push(item.name);
                    }
                });
            });
            setSelectedMaintenanceType(filteredTypes);
            setSelectedMaintenanceTypeName(filteredTypeNames);
        } else {
            setSelectedMaintenanceType(0);
            setSelectedMaintenanceTypeName("");
        }
    };

    //set start date
    const HandleStartDate = (date) => {
        setStartDate(date);
    };

    //set end date
    const HandleEndDate = (date) => {
        setEndDate(date);
    };

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setIsFilterDrawerOpen(open);
    };

    const filter = () => {
        return (
            <DetailFilter
                poolData={poolData}
                poolIds={poolIds}
                HandlePool={HandlePool}
                maintenanceTypeMultiple={true}
                maintenanceTypes={maintenanceTypes}
                selectedMaintenanceTypeName={selectedMaintenanceTypeName}
                HandleMaintenanceTypeChange={HandleMaintenanceTypeChange}
                startDate={startDate}
                HandleStartDate={HandleStartDate}
                endDate={endDate}
                HandleEndDate={HandleEndDate}
            />
        );
    };

    const HandleApplyFilter = () => {
        var payload = {
            poolIds: poolIds ? poolIds : [],
            maintenanceTypeIds: selectedMaintenanceType ? selectedMaintenanceType : [],
            startDate: startDate,
            endDate: endDate,
        };
        setExcelFilterState(payload);
    };

    const HandleClearFilter = () => {
        setPoolIds([]);
        setSelectedMaintenanceType([]);
        setSelectedMaintenanceTypeName([]);
    };

    return (
        <div>
            <Grid container item md={12}>
                <FilterDrawer
                    open={isFilterDrawerOpen}
                    onOpen={toggleDrawer(true)}
                    onClose={toggleDrawer(false)}
                    HandleClearFilter={HandleClearFilter}
                    HandleApplyFilter={HandleApplyFilter}
                    downloadExcel={() =>
                        dispatch(
                            postExportTasksForUpdateDate({
                                ...excelFilterState,
                            })
                        )
                    }
                    detailFilter={filter()}
                />
                <FilterButton onClick={() => toggleDrawer(true)} />
                {/* Tabs */}
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Tabs value={value} onChange={handleChange} centered>
                        <Tab label={t("MaintenancePlans")} {...a11yProps(0)}></Tab>
                    </Tabs>
                </Grid>

                <Grid item xs={1} sm={3} md={4} lg={4}></Grid>

                {/* Buttons */}
                <Grid item xs={12} sm={6} md={4} lg={4}>
                    {/* Excel File Outline */}
                    {/* <Tooltip title={t("ExcelFileOutline")}>
                        <IconButton
                            onClick={() =>
                                dispatch(
                                    postExportTasksForUpdateDate({
                                        ...excelFilterState,
                                    })
                                )
                            }
                            size="large">
                            <GetAppIcon style={{ color: "#008000", width: 50, height: 50 }} />
                        </IconButton>
                    </Tooltip> */}

                    {/* Excel Butonu */}
                    <Tooltip title={t("ChooseExcelFile")}>
                        <IconButton component="label" disabled={disableExcel} size="large">
                            <UpdateDateFromExcel
                                callBackTabData={callBackTabData}
                                disableExcel={disableExcel}
                                setFormData={setFormData}
                                tabId={value} //tabId to upload correct api endpoint
                            />
                        </IconButton>
                    </Tooltip>

                    {/* İptal Butonu */}
                    <Tooltip title={t("Cancel")}>
                        <IconButton component="label" onClick={cancelUpload} disabled={disableCancel} size="large">
                            <GiCancel style={{ width: 50, height: 50, padding: 0, fill: disableCancel ? "#bdbdbd" : "#E82114" }} />
                        </IconButton>
                    </Tooltip>

                    {/* Upload Butonu */}
                    <Tooltip title={t("DataUpload")}>
                        <IconButton component="label" disabled={disableUpload} size="large">
                            <FaUpload disableUpload={disableUpload} style={{ fill: disableUpload ? "#bdbdbd" : "#00a4b9", width: "50px", height: "50px", padding: "0px" }} onClick={uploadExcel} />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>

            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={(value) => {
                    setValue(value);
                }}
                enableMouseEvents
            >
                {/* callback function'dan gelen data ilgili komponente props olarak gidip tabloyu doldurur */}
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <PlannedMaintenanceTable plannedMaintenanceExcel={plannedMaintenanceExcel} warningList={warningList} />
                </TabPanel>
            </SwipeableViews>
        </div>
    );
}

export default PlannedMaintenanceUpdate;
